import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import Table from "./components/viewCompany";

const DataTable = ({ match }) => {
  const [currentId, setCurrentId] = useState(match.params.id);

  useEffect(() => {
    setCurrentId(match.params.id);
    return () => {
      setCurrentId("");
    };
  }, [match.params.id]);
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Company</h3>
          {/* <h3 className="page-subhead subhead">Use this elements, if you want to show some hints or additional
          information
        </h3> */}
        </Col>
      </Row>
      <Row>
        <Table id={currentId} />
      </Row>
    </Container>
  );

  // DataTable.propTypes = {
  //   t: PropTypes.func.isRequired
  // };
};
export default withTranslation("common")(DataTable);
